import * as ngCore from '@angular/core'

import { AtnDsTableStore } from '../../../../store'

@ngCore.Component({
  imports: [],
  selector: 'excel-action',
  standalone: true,
  template: `
   <i
      class="atn-icon atn-download atn-blue"
      [class.disabled]="isDownloadingSg()"
      (click)="downloadIconClickHandler()"
    ></i>
  `,
})
export class Component {
  /** @see {@link AtnDsTableStore} */
  public readonly store = ngCore.inject(AtnDsTableStore)
  /** TODO:  */
  public readonly isDownloadingSg = ngCore.computed(
    (plugin = this.store.excelPluginSg()) =>
      !!plugin?.feature.selectors.isDownloading.asSignal(),
  )

  /** TODO:  */
  public downloadIconClickHandler() {
    this.store
      .excelPluginSg()
      ?.feature.actions.download.from(
        'Table.WidgetActions.Icons.Download.Clicked',
      )
      .dispatch()
  }
}
